import cyGoods from './cyGoods';
import wzGoods from './wzGoods';
import { CDN_URL } from './index';

// 传奇2.5D游戏商品处理
const handleScGoods = goodsList => {
  const first = [
    {
      id: 326,
      icon: `${CDN_URL}/offlinePay/cq/gift/3.png`
    },
    {
      id: 327,
      icon: `${CDN_URL}/offlinePay/cq/gift/2.png`
    },
    {
      id: 328,
      icon: `${CDN_URL}/offlinePay/cq/gift/1.png`
    }
  ];
  const diamond = [1, 2, 29, 3, 4, 5, 6, 7, 9, 10];
  const daily = [332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 512, 513, 514, 515, 516, 517, 1491, 1492, 1493, 1494, 1495, 1496, 2092, 2093, 2094, 2095, 2096, 2097, 16013, 16014, 16015, 16016, 16017, 16018, 2098, 2099, 2100, 2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 16001, 16002, 16003, 16004, 16005, 16006, 16007, 16008, 16009, 16010, 16011, 16012, 16021, 16022, 16023, 16024, 16025, 16026, 18001, 18002, 18003, 18004, 18005, 18006, 18007, 18008, 18009, 18010, 18011, 18012, 18013, 18014, 18015];

  const giftList = {
    first: [],
    diamond: [],
    daily: [],
    other: []
  };
  goodsList.map(item => {
    const firstItem = first.find(giftItem => giftItem.id == item.goods_id);
    const diamondItem = diamond.find(giftItem => giftItem == item.goods_id);
    const dailyItem = daily.find(giftItem => giftItem == item.goods_id);
    if (firstItem) {
      giftList.first.push({
        id: item.goods_id,
        name: item.goods_name,
        price: item.goods_amount / 100,
        icon: firstItem.icon
      });
    } else if (diamondItem) {
      giftList.diamond.push({
        id: item.goods_id,
        name: item.goods_name,
        price: item.goods_amount / 100,
        icon: `${CDN_URL}/offlinePay/cq/pay/${item.goods_id}.png`
      });
    } else if (dailyItem) {
      giftList.daily.push({
        id: item.goods_id,
        name: item.goods_name,
        price: item.goods_amount / 100,
        icon: handleSCIcon(item.goods_amount / 100)
      });
    } else {
      giftList.other.push({
        id: item.goods_id,
        name: item.goods_name,
        price: item.goods_amount / 100,
        icon: handleSCIcon(item.goods_amount / 100)
      });
    }
  });
  return giftList;
};

// 处理沙城无双icon
const handleSCIcon = price => {
  if (price <= 50) {
    return `${CDN_URL}/offlinePay/cq/gift/3.png`;
  } else if (price > 500) {
    return `${CDN_URL}/offlinePay/cq/gift/1.png`;
  } else {
    return `${CDN_URL}/offlinePay/cq/gift/2.png`;
  }
};

export default {
  // 乐游游推荐
  lyytj: {
    appkey: '100008656',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lyy.png`,
    game: '帝王荣耀：荣耀之怒'
  },
  lslh: {
    appkey: '100008184',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lslh.png`,
    game: '帝王荣耀：乱世龙魂'
  },
  // 帝王荣耀 安卓包
  dwryAndroid: {
    appkey: '100008984',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lyy.png`,
    game: '帝王荣耀'
  },
  // 王者重生 跟赤焰一样规则，但是icon和档位不一样
  wzcs: {
    appkey: '200009201',
    appId: 'wxdfe94bc104c6a12a',
    goods: wzGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/ryzz.png`,
    game: '怒战皇城-荣耀至尊',
    hideRebate: true
  },
  // 至尊无极 王者重生游戏
  zzwj: {
    appkey: '200009490',
    appId: 'wxdfe94bc104c6a12a',
    goods: wzGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/zzwj.png`,
    game: '至尊无极-吾皇问世',
    hideRebate: true
  },
  // 热血至尊
  rxzz: {
    appkey: '100008583',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/rxzz.png`,
    game: '热血至尊之超燃之战'
  },
  cy: {
    appkey: '100008143',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/cy.png`,
    game: '破晓开天之怒战雷霆'
  },
  // 烈焰裁决之怒火战歌公众号
  lycj: {
    appkey: '100008211',
    appId: 'wxdfe94bc104c6a12a',
    goods: cyGoods,
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lycj.png`,
    game: '烈焰裁决之怒火战歌'
  },
  // 运营测试
  yycs: {
    appkey: '100008622',
    appId: 'wxdfe94bc104c6a12a',
    gameIcon: `//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/lycj.png`,
    game: '沙城测试',
    handleGoods: handleScGoods
  },
  zzby: {
    appkey: '100008359',
    appId: 'wxdfe94bc104c6a12a',
    game: '一战称王',
    gameIcon: '//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/icon/yzcw.png',
    handleGoods: handleScGoods
  }
  // cq: {
  //   appkey: '100007973',
  //   appId: 'wxfe1db839d8c5cda1',
  //   game: '东城二点五',
  //   gameIcon: '',
  //   handleGoods: handleScGoods
  // }
};

// 赤焰和王者重生游戏都是用配置商品
export const cyGames = ['lyytj', 'lslh', 'rxzz', 'cy', 'lycj', 'wzcs', 'zzwj', 'dwryAndroid'];

// 王者重生游戏不支持任意金额大额充值
export const wzcsGames = ['zzwj']